import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function isNumberOnly(value: string): boolean {
    return /^[0-9]*$/.test(value);
  }

  return {
    isNumberOnly,
  };
}
